import React, { useState, useEffect } from "react";
import "../../assets/styles/local/WorkflowAutomation.css";
import { Col, Row } from "react-bootstrap";
import coffee from "../../assets/icons/WorkflowAutomation/coffee.svg";
import styles from "../Assets/genralTabContent.module.css";
import { Select } from "antd";
import FormSelectionModel from "./FormSelectionModel";

import { useDispatch, useSelector } from "react-redux";
import { GetSubmodulesByModuleId } from "../../redux/actions/workflowAutomationActions";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddEditWorkflow = (props) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // Module Dropdown Binding
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );

  const [moduleOption, setModuleOption] = useState([
    {
      // label: "Select Module",
      label: t("Select Module "),
      value: "",
      disabel: true,
    },
  ]);

  useEffect(() => {
    let moduleList = getAppSideNavOptions.map((o) => {
      return {
        label: o.modulename,
        value: o.moduleid,
        disabel: false,
      };
    });
    setModuleOption([...moduleOption, ...moduleList]);
  }, [getAppSideNavOptions]);

  // Submodule / Section Tab Dropdown binding
  const [sectionOption, setSectionOption] = useState([
    {
      // label: "Select Section",
      label: t("Select section "),
      value: "",
      disabel: true,
    },
  ]);

  const onModuleChange = (moduleId) => {
    GetSubmodulesByModuleId(moduleId)
      .then((res) => {
        if (
          res.status &&
          res.data &&
          res.data.data &&
          res.data.data.length > 0
        ) {
          let subModules = res.data.data.map((o) => {
            return {
              label: o.subModuleName,
              value: o.subModuleId,
              disable: false,
            };
          });

          setSectionOption([
            {
              // label: "Select Section",
              label: t("Select section "),
              value: "",
              disabel: true,
            },
            ...subModules,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [showFormSelectionPopup, setShowFormSelectionPopup] = useState(false);
  const [showTip, setShowTip] = useState(true);

  const [workflowName, setWorkflowName] = useState("");
  const [selectedModule, setSelectedModule] = useState({
    moduleId: "",
    moduleName: "",
  });
  const [selectedSubmodule, setSelectedSubmodule] = useState({
    subModuleId: "",
    subModuleName: "",
  });

  const [form, setForm] = useState({
    formId: "",
    formName: "",
  });

  const [errors, setErrors] = useState({
    workflowNameError: false,
    moduleNameError: false,
    sectionTabNameError: false,
    formNameError: false,
  });

  const handleClose = () => {
    setShowFormSelectionPopup(false);
  };

  const handleSelectForm = (form) => {
    setForm(form);
    handleClose();
  };

  const startWorkflowAutomation = () => {
    if (!validform()) return;

    let data = {
      workflowName: workflowName,
      ...selectedModule,
      ...selectedSubmodule,
      ...form,
    };

    props.submit(data);
  };

  const validform = () => {
    let errorInForm = false;
    let _errors = JSON.parse(JSON.stringify(errors));

    // Error in Workflow Name
    if (workflowName === "") {
      errorInForm = true;
      _errors.workflowNameError = true;
    } else {
      errorInForm = false;
      _errors.workflowNameError = false;
    }

    // Error in Module Name
    if (selectedModule.moduleId === "") {
      errorInForm = true;
      _errors.moduleNameError = true;
    } else {
      errorInForm = false;
      _errors.moduleNameError = false;
    }

    // Error in Section Tab Name
    if (selectedSubmodule.subModuleId === "") {
      errorInForm = true;
      _errors.sectionTabNameError = true;
    } else {
      errorInForm = false;
      _errors.sectionTabNameError = false;
    }

    // Error in Form
    if (form.formId === "") {
      errorInForm = true;
      _errors.formNameError = true;
    } else {
      errorInForm = false;
      _errors.formNameError = false;
    }

    setErrors(_errors);
    return !errorInForm;
  };

  return (
    <div className="add-edit-workflow-body p-4 ps-5 pe-5">
      <Row>
        <Col xl={7}>
          {showTip && (
            <div className="ps-5">
              <div className="d-flex">
                <img src={coffee} alt="tooltip" style={{ minWidth: "30px" }} />
                &nbsp;&nbsp;
                <div className="pt-1" style={{ fontSize: "18px" }}>
                  {/* Tip */}
                  {t("Tip")}
                </div>
              </div>
              <div style={{ width: "22vw" }} className="pt-3">
                <span>
                  {/* Start to add a distinctive name to this workflow. */}
                  {t("Start to add a distinctive name to this workflow.")}
                </span>{" "}
                <br />
                <span>
                  {/* Then select the module an tab where this workflow Should be
                  applied. */}
                  {t(
                    "Then select the module an tab where this workflow Should be                   applied.",
                  )}
                </span>
              </div>
            </div>
          )}
        </Col>
        <Col xl={5}>
          <div className="Workflow-form pt-4">
            {/* Workflow Name */}
            <div className="workflow_input_wrap" style={{ marginBottom: 0 }}>
              <label className="workflow_form_label">
                {/* Workflow Name */}
                {t("Workflow Name")}
              </label>
              <div className="input_wrap">
                <input
                  // placeholder="Add workflow name"
                  placeholder={t("Add workflow name")}
                  type="text"
                  value={workflowName}
                  onChange={(e) => setWorkflowName(e.target.value)}
                  style={{ fontSize: "14px" }}
                />
              </div>
            </div>
            {errors && errors.workflowNameError && (
              <label className="form-error">
                {/* Workflow Name is Required */}
                {t("Workflow Name is Required")}
              </label>
            )}

            {/* Module Selection  */}
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">
                {/* Module */}
                {t("Module ")}
              </label>
              <div className="input_wrap">
                <select
                  placeholder="select"
                  className="cursor-pointer"
                  value={selectedModule.moduleId}
                  onChange={(e) => {
                    let _selectedModule = moduleOption.find(
                      (o) => o.value === e.target.value,
                    );
                    setSelectedModule({
                      moduleId: _selectedModule?.value,
                      moduleName: _selectedModule?.label,
                    });
                    onModuleChange(e.target.value);
                    setShowTip(false);
                  }}
                >
                  {moduleOption.length &&
                    moduleOption.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {errors && errors.moduleNameError && (
              <label className="form-error">
                {/* Module is Required */}
                {t("Module is Required")}
              </label>
            )}

            {/* Section Selection  */}
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">
                {/* Section Tab */}
                {t("Section Tab")}
              </label>
              <div className="input_wrap">
                <select
                  placeholder="select"
                  className="cursor-pointer"
                  value={selectedSubmodule.subModuleId}
                  onChange={(e) => {
                    let _selectedSubModule = sectionOption.find(
                      (o) => o.value === e.target.value,
                    );
                    setSelectedSubmodule({
                      subModuleId: _selectedSubModule.value,
                      subModuleName: _selectedSubModule.label,
                    });
                  }}
                >
                  {sectionOption.length &&
                    sectionOption.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {errors && errors.sectionTabNameError && (
              <label className="form-error">
                {/* Section Tab is Required */}
                {t("Section Tab is Required")}
              </label>
            )}

            {/* Form Slection */}
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">
                {/* Form */}
                {t("Form")}
              </label>
              <div className="input_wrap">
                <input
                  className="form-selection cursor-pointer"
                  // placeholder="Select Form"
                  placeholder={t("select form")}
                  type="text"
                  readOnly
                  style={{ fontSize: "14px" }}
                  value={form.formName}
                  onClick={() => {
                    setShowFormSelectionPopup(true);
                  }}
                />
              </div>
            </div>
            {errors && errors.formNameError && (
              <label className="form-error">
                {/* Form is Required */}
                {t("Form is Required ")}
              </label>
            )}

            {/* Workflow Automation Action */}
            <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
              <button
                className="start-workflow-btn p-2"
                onClick={() => {
                  startWorkflowAutomation();
                }}
              >
                {/* Start */}
                {t("Start ")}
              </button>
            </div>
          </div>
          <FormSelectionModel
            animation={true}
            show={showFormSelectionPopup}
            close={handleClose}
            select={handleSelectForm}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AddEditWorkflow;
